import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component
class MenuTable extends Vue {
  @Prop({ default: () => [] }) data
  @Prop({ default: false }) loading: boolean
  @Prop({ default: false }) disabled: boolean
  @Prop({ default:  () => {return {}} }) appCheckMap

  childMap: { [name: string]: string[] } = {}
  parentMap: { [name: string]: string } = {}
  checkMap: { [name: string]: boolean } = {}

  @Watch('data', { immediate: true, deep: true })
  gen(val) {
    this.initCheckMap(val)
  }

  initCheckMap(data) {
    if (this.appCheckMap && Object.keys(this.appCheckMap).length) {
      this.checkMap = this.appCheckMap.checkMap
      this.childMap = this.appCheckMap.childMap
      this.parentMap = this.appCheckMap.parentMap
      return
    }
    const checkMap = {}
    const childMap = {}
    const parentMap = {}
    const queue = []
    for (let i = 0; i < data.length; i++) {
      queue.push(data[i])
      while (queue.length) {
        const first = queue.shift()
        if (first.children.length) {
          first.children.forEach(item => {
            queue.push(item)
            parentMap[item.id] = first.id
          })
        }
        childMap[first.id] = first.children.map(item => item.id)
        checkMap[first.id] = first.attribute.isAuthed
      }
    }
    this.checkMap = checkMap
    this.childMap = childMap
    this.parentMap = parentMap
  }

  check(id, bool) {
    // 勾选全部子节点
    this.checkMap[id] = bool
    this.childMap[id].forEach(item => {
      this.checkMap[item] = bool
      if (this.childMap[item].length) {
        this.check(item, bool)
      }
    })
    // 勾选自己的父节点
    if (bool) {
      const a = this.parentMap[id]
      this.checkMap[a] = true
      const b = this.parentMap[a]
      if (b) {
        this.checkMap[b] = true
      } else return
      const c = this.parentMap[b]
      if (c) {
        this.checkMap[c] = true
      } else return
      const d = this.parentMap[c]
      if (d) {
        this.checkMap[d] = true
      } else return
      const e = this.parentMap[d]
      if (e) {
        this.checkMap[e] = true
      } else return
    }
  }

  render() {
    let genParentChildren = null
    const genBtnsAndPages = arr => {
      const btns = arr.filter(item => {
        return item.attribute.category === 2
      })

      const pages = arr.filter(item => {
        return item.attribute.category === 1
      })

      return (
        <div>
          {btns.length > 0 ? (
            <div style={{ borderBottom: pages.length > 0 ? '1px solid #eee' : 'none' }}>
              {btns.map(item => {
                return (
                  <div style="width: 150px; display: inline-block; padding: 8px">
                    <a-checkbox checked={this.checkMap[item.id]} onChange={e => this.check(item.id, e.target.checked)} disabled={this.disabled}>
                      <ellipsis length={12} tooltip>
                        {this.$t(item.title)}
                      </ellipsis>
                    </a-checkbox>
                  </div>
                )
              })}
            </div>
          ) : null}

          {pages.map((item, index) => {
            if (index !== pages.length - 1) {
              return <div style="border-bottom: 1px solid #eee">{genParentChildren(item)}</div>
            } else {
              return <div>{genParentChildren(item)}</div>
            }
          })}
        </div>
      )
    }

    genParentChildren = o => {
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'strech'
          }}
        >
          <div
            style={{
              flex: 'none',
              width: '150px',
              padding: '8px',
              borderRight: '1px solid #eee'
            }}
          >
            <a-checkbox
              id={`cb-${o.id}`}
              checked={this.checkMap[o.id]}
              disabled={this.disabled}
              onChange={e => this.check(o.id, e.target.checked)}
            >
              <ellipsis length={12} tooltip>
                {this.$t(o.title)}
              </ellipsis>
            </a-checkbox>
          </div>
          {o.children.length > 0 ? genBtnsAndPages(o.children) : null}
        </div>
      )
    }

    const comp = this.data.map(item => {
      const temp = genParentChildren(item)
      return <div style="border-bottom: 1px solid #eee">{temp}</div>
    })

    return (
      <a-spin spinning={this.loading} style="width: 100%;">
        <div style="border: 1px solid #eee; border-bottom: none; margin-bottom: 16px; width: 100%; overflow-x: auto">
          {comp}
        </div>
      </a-spin>
    )
  }
}

export default MenuTable
